import { createAction } from '@reduxjs/toolkit';

export const resetAllState = createAction('RESET_ALL_STATE');